export class UsuarioHospital {
    constructor(
        public idHospital: number,
        public cuil: string,
        public idRol: number, //administrador / enfermero / médico / laboratorio / jefe UTI - INT 0  - 1 - 2 - 3 - 4 - 
        public estadoLaboral: number,   //activo / licencia / baja - INT 0  - 1 - 2 - 
        public sync_id?: number,
        public sync_id_usuario?: number
    ){}
}